module.exports = __webpack_public_path__ + "media/images/img_man-261099a3f99fc461403d7f9541cbac1b.png";